import React, { FC } from 'react';
import classNames from 'classnames';
import { PartsProduct } from '@app/react/const/type';
import { NO_IMAGE_PRODUCT_PATH } from '@app/react/const/variables';

export interface ProductThumbnailUnderbarProps {
    className?: string;
    product: PartsProduct;
    checked: boolean;
    onClick: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        product: PartsProduct
    ) => void;
}

export const ProductThumbnailUnderbar: FC<ProductThumbnailUnderbarProps> = (
    props,
) => {
    const {
        className, product, checked, onClick,
    } = props;

    const { name } = product;
    const imgPath = product.productImages[0] || NO_IMAGE_PRODUCT_PATH;

    return (
        <button
            type="button"
            className={classNames(
                'product-thumbnail-underbar',
                { selected: checked },
                className,
            )}
            onClick={(ev) => onClick(ev, product)}
        >
            <div className="body">
                <img src={imgPath} alt={name} />
                <span>{name}</span>
            </div>
        </button>
    );
};
